<template>
    <v-dialog
        v-model="dialogDelete"
        :max-width="maxWidth"
        :persistent="persistent"
        @click:outside="$emit('close', 'modelClose')"
        @input="(val) => $emit('update:is-delDialog-sidebar-active', val)">
        <v-card>
            <v-card-title>{{dialogTitle}}</v-card-title>

            <slot name="dialogContent"></slot>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :loading="subLoading"
                    @click="$emit('deleteItemConfirm')"
                >
                    {{okText}}
                </v-btn>
                <v-btn
                    outlined
                    @click="$emit('close')"
                >
                    {{cancelText}}
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
	model: {
		prop: 'delDialog',
		event: 'update:is-delDialog-sidebar-active',
	},
    props: {
        dialogDelete: Boolean,
        dialogTitle: String,
        maxWidth: {
            type: String,
            default: "500px"
        },
        subLoading: Boolean,
        okText: {
            type: String,
            default(){
                return this.$t('btn.submit')
            }
        },
        cancelText: {
            type: String,
            default(){
                return this.$t('btn.close')
            }
        },
        persistent: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style lang='scss' scoped>
    ::v-deep{
        .v-card__title{
            word-break: break-word;
            line-height: 28px;
            font-size: 18px !important;
        }
    }
</style>